import "./PropertyStewardship.module.css";
import Navigation from "@/reusable_sections/Header";
import Stewardship from "./sections/Stewardship";
import Management from "./sections/Management";
import HowWeManage from "./sections/HowWeManage";
import Footer from "@/reusable_sections/Footer";
export default function PropertyStewardshipPage() {
  return <div>
      <Navigation />
      <Stewardship />
      <Management />
      <HowWeManage />
      <Footer />
    </div>;
}